export const ADD_HEPIC_USER = 'ADD_HEPIC_USER'
export const UPDATE_HEPIC_USER_ROLE = 'UPDATE_HEPIC_USER_ROLE'
export const CANCEL_UPDATE_HEPIC_USER_ROLE = 'CANCEL_UPDATE_HEPIC_USER_ROLE'
export const REMOVE_HEPIC_USER = 'REMOVE_HEPIC_USER'
export const TOGGLE_HEPIC_METRIC = 'TOGGLE_HEPIC_METRIC'
export const TOGGLE_HEPIC_AUTO_ADD_USERS = 'TOGGLE_HEPIC_AUTO_ADD_USERS'
export const CREATE_HEPIC_TOKEN = 'CREATE_HEPIC_TOKEN'
